export const linkedinEditorialRawErrorCodeToErrorMessageMapping = {
  10001: _TL_('Adult Content'),
  10002: _TL_('Affiliate Advertising'),
  10003: _TL_('Alcohol'),
  10004: _TL_('Animal or Animal Products'),
  10005: _TL_('Back button not working'),
  10006: _TL_('Copyrighted content'),
  10007: _TL_('Counterfeit Goods'),
  10008: _TL_('Cryptocurrency'),
  10009: _TL_('Data collection and privacy'),
  10010: _TL_('Deceptive Behavior'),
  10011: _TL_('Excessive Capitalization'),
  10012: _TL_('Excessive contact information'),
  10013: _TL_('Excessive negative response'),
  10014: _TL_('Fake Document'),
  10015: _TL_('Gambling and sweepstakes'),
  10016: _TL_('General trademark issues'),
  10017: _TL_('Hacking and cracking'),
  10018: _TL_('Hate speech, violence, discrimination and opposition'),
  10019: _TL_('Health Matters'),
  10020: _TL_('Illicit or Recreational Drugs and Related Products'),
  10021: _TL_('Implied affiliation'),
  10022: _TL_('Inappropriate language or image'),
  10023: _TL_('Inappropriate name'),
  10024: _TL_('Inconsistent display and landing page URLs'),
  10025: _TL_('Job posting without listed state'),
  10026: _TL_('Legitscript Missing'),
  10027: _TL_('LinkedIn in Ad'),
  10028: _TL_('Loans & Financial Services'),
  10029: _TL_('Malicious Software or Browser'),
  10030: _TL_('Medical Devices and Treatments'),
  10031: _TL_('Misinformation'),
  10032: _TL_('Misleading Claims'),
  10033: _TL_('Mismatched ad text and landing page content'),
  10034: _TL_('Missing privacy policy'),
  10035: _TL_('UK FCA Authorization '),
  10036: _TL_('Missing URL for campaign objective'),
  10037: _TL_('Non-matching languages'),
  10038: _TL_('Non-standard text'),
  10039: _TL_('Non-functional site'),
  10040: _TL_('Occult Pursuits'),
  10041: _TL_('Offensive Language'),
  10042: _TL_('Offensive to Good Taste'),
  10043: _TL_('Offer not found'),
  10044: _TL_('Over-the-counter'),
  10045: _TL_('Pharmacy and Telehealth'),
  10046: _TL_('Phishing'),
  10047: _TL_('Pop-up or pop-under'),
  10048: _TL_('Prescription drugs'),
  10049: _TL_('Prohibited Dating Services'),
  10050: _TL_('Prohibited Political'),
  10051: _TL_('Questionable downloads'),
  10052: _TL_('Resale of event tickets'),
  10053: _TL_('Ringtones and Video Games'),
  10054: _TL_('Scams'),
  10055: _TL_('Solicitation of funds'),
  10056: _TL_('Incomplete Ads'),
  10057: _TL_('Test taking services'),
  10058: _TL_('Tobacco products or cigarettes'),
  10059: _TL_('Unclear billing practices'),
  10060: _TL_('Unsupported competitive claims'),
  10061: _TL_('Unsupported language'),
  10062: _TL_('Weapons and explosives'),
  10063: _TL_('Other'),
};
